<template>
  <div class="login">
    <div class="header">
      <div class="logo">
        <img src="../../assets/img/logo.png" alt="" @click="$router.push('/')">
        <span>欢迎登录</span>
      </div>
    </div>
    <div class="main">
      <div class="main-content">
        <div class="login-form">
          <div class="loginBg">
            <p class="t" style="overflow:hidden;">
              <span class="tlspan fl">用户登录</span>
              <span class="trspan fr" @click="goRegister">
                立即注册
              </span>
            </p>
            <div class="clear"></div>
            <p class="li telinp">
              <span class="icon"></span>
              <input v-model="loginParam.userAccount" @keyup.enter="handleLogin" type="text" placeholder="手机号/账号" autocomplete="off">
              <span class="err-box">
                <span class="error">{{ errorMessage.userAccount }}</span>
              </span>
            </p>
            <p class="li telinp passinp">
              <span class="icon"></span>
              <input v-model="loginParam.password" @keyup.enter="handleLogin" class="huise error" type="password" placeholder="请输入密码">
              <span class="err-box">
                <span class="error">{{ errorMessage.password }}</span>
              </span>
            </p>
            <p class="li yzminp">
              <span class="icon fl"></span>
              <input v-model="loginParam.captcha" @keyup.enter="handleLogin" style="width: 100px" class="fl error" type="text" placeholder="请输入验证码">
              <img style="float: right;width: 120px;height: 41px;cursor: pointer" :src="$urlPrefix + '/front/userCenter/captcha/' + uuid" alt="" @click="getRandom">
              <span class="err-box">
                <span class="error">{{ errorMessage.captcha }}</span>
              </span>
            </p>
            <p class="li sbinp">
              <span @click="handleLogin">登 录</span>
            </p>
            <p class="li telinp forgetinp">
              <span style="color:#f58357;margin-right:5px;">{{ errorMessage.login }}</span>
              <span style="float: right"><span class="forgetBtn" @click="goForget">忘记密码</span> | <span class="forgetBtn" @click="goRegister">立即注册</span></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer-content">
        <span>版权所有 : 成都高投盈创动力投资发展有限公司 </span>
        <span class="tel">&nbsp;&nbsp;&nbsp;&nbsp;联系电话：028-85225102 </span>
      </div>
    </div>
  </div>

</template>

<script>
import {
  getToken,
  setToken,
  removeToken
} from '../../utils/cookie'

export default {
  name: 'Login',
  data() {
    return {
      imgUrl: '',
      uuid: '',
      loginParam: {
        userAccount: '',
        password: '',
        captcha: ''
      },
      errorMessage: {
        userAccount: '',
        password: '',
        captcha: '',
        login: ''
      }

    }
  },
  created() {
    this.getRandom()
  },
  methods: {
    getRandom() {
      const $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      const maxPos = $chars.length
      let pwd = ''
      for (let i = 0; i < 32; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
      }
      this.uuid = pwd
    },
    goForget() {
      window.open(this.$winpowUrl + '/user/forget.html?type=school', '_self')
    },
    goRegister() {
      window.open(this.$winpowUrl + '/user/register.html?type=school', '_self')
    },
    validateLoginForm() {
      this.errorMessage = {
        userAccount: '',
        password: '',
        captcha: '',
        login: ''
      }
      !this.loginParam.userAccount ? this.errorMessage.userAccount = '请输入手机号/账号' : this.errorMessage.userAccount = ''
      !this.loginParam.password ? this.errorMessage.password = '请输入登陆密码' : this.errorMessage.password = ''
      !this.loginParam.captcha ? this.errorMessage.captcha = '请输入图形验证码!' : this.errorMessage.captcha = ''
      if (!this.loginParam.userAccount || !this.loginParam.password || !this.loginParam.captcha) {
        return false
      } else {
        return true
      }
    },
    handleLogin() {
      const validate = this.validateLoginForm()
      if (!validate) {
        return
      }
      this.loginParam.id = this.uuid
      this.$post('/front/userCenter/login', this.loginParam).then(res => {
        if (res) {
          setToken(res.token)
          this.$store.commit('setUserData', res.user)
          localStorage.setItem('userData', JSON.stringify(res.user))
          this.$store.commit('setToken', res.token)
          this.$router.push('/')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  .fl {
    float: left;
  }
  .fr {
    float: right;
  }
  .header {
    width: 100%;
    height: 100px;
    background-color: #FFFFFF;
    .logo {
      width: 1200px;
      height: 100%;
      margin: 0 auto;

      img {
        width: 188px;
        height: 80px;
        margin-top: 10px;
        float: left;
        cursor: pointer;
      }
      span {
        font-size: 30px;
        color: #474f59;
        margin-top: 34px;
        margin-left: 40px;
        font-weight: bold;
        float: left;
      }
    }
  }
  .main {
    width: 100%;
    background-color: #83cf8f;
    .main-content {
      width: 1200px;
      height: 750px;
      margin: 0 auto;
      background: url('../../assets/img/login_bg.png') no-repeat left center;
      .login-form {
        float: right;
        width: 368px;
        height: 424px;
        background: url('../../assets/img/lobg.png') no-repeat left top;
        margin-top: 152px;
        .err-box {
          position: absolute;
          color: #f58357;
          left: 0;
          top: 40px;
          font-size: 14px;
        }
        .loginBg {
          width: 289px;
          margin: 0 auto;
          p {
            position: relative;
          }
          p.li {
            border: 0px solid #bebebe;
            border-radius: 5px;
            height: 41px;
            margin-bottom: 28px;
            .icon {
              display: block;
              width: 20px;
              height: 24px;
              float: left;
              margin-top: 12px;
              margin-left: 14px;
            }
            input {
              margin-top: 3px;
              margin-left: 0;
              font-size: 14px;
              padding: 10px;
              width: 186px;
            }
          }
          p.t {
            margin-top: 48px;
            margin-bottom: 28px;
            .tlspan {
              font-size: 18px;
              color: #f58357;
            }
            .trspan{
              cursor: pointer;
              color: #f58357;
              font-size: 14px;
            }
            .trspan:hover {
              text-decoration: underline;
            }
          }
          p.telinp {
            background: url('../../assets/img/telinp.png') no-repeat left top;
            margin-top: 28px;
            span.icon {
              background: url('../../assets/img/linputbg.png') no-repeat 0 0;
            }
          }
          p.passinp span.icon {
            background: url('../../assets/img/linputbg.png') no-repeat -27px 0;
          }
          p.yzminp {
            background: url('../../assets/img/yzminp.png') no-repeat left top;
            span.icon {
              background: url('../../assets/img/linputbg.png') no-repeat -54px 0;
              margin-top: 10px;
            }
          }
          p.sbinp {
            margin-bottom: 12px;
            span {
              padding: 8px 123px;
              background-color:#F58357;
              color: #ffffff;
              font-size: 18px;
              border-radius: 3px;
              line-height: 35px;
              cursor: pointer;
            }
            span:hover {
              opacity: 0.8;
            }
          }
          p.forgetinp {
            text-align: center;
            height: auto;
            margin-top: 0px;
            margin-bottom: 0px;
            background: none;
            border: none;
            span {
              font-size: 14px;
            }
          }
          .forgetBtn {
            cursor: pointer;
          }
          .forgetBtn:hover {
            color: #f58357;
            text-decoration: underline;
          }
        }
      }
    }
  }
  .footer {
    background-color: #363636;
    height: 75px;
    line-height: 75px;
    text-align: center;
    color: #bababa;
    .footer-content {
      width: 1200px;
      margin: 0 auto;
      font-size: 14px;
      .tel {
        margin-left: 160px;
        background: url('../../assets/img/linputbg.png') no-repeat -42px -124px;
      }
    }
  }
}
</style>
